import { usePlayerRuntime } from "./usePlayerRuntime";

/**
 * Runtime side-effects for the player (analytics, ads, limits, audio state sync).
 *
 * IMPORTANT: This component intentionally does NOT wrap the app tree.
 * It may re-render frequently (e.g., when the current item changes), but by being
 * mounted as a sibling to the UI tree it avoids cascading re-renders across the app.
 */
const PlayerRuntimeProvider = () => {
  usePlayerRuntime();

  return null;
};

export default PlayerRuntimeProvider;
